const stocker = new URL('../../icons/stocker.png', import.meta.url).href

export default {
  type: 'Stocker',
  description: 'stocker',
  icon: stocker,
  group: 'SCS',
  model: {
    type: 'STOCKER',
    left: 100,
    top: 100,
    width: 240,
    height: 100,
    radius: 10
  }
}
